export default __webpack_public_path__ + "static/media/Amortisation-straightline.12fd1fe5.svg";